import {Modals} from './modals';

let modals;
const CLASSES = {
  active: 'is-active',
};

// Здесь реализован пример открытия модалки через колбэк закрытия
// const openModalInCloseCallback = (name, context = this) => {
//   context._enableScrolling = false;
//   context._setSettings('default');
//   modals.open(name);
// };

// closeCallback() {
//   openModalInCloseCallback('modal-5');
// },

const settings = {
  'default': {
    preventDefault: true,
    stopPlay: true,
    lockFocus: true,
    startFocus: true,
    focusBack: true,
    eventTimeout: 400,
    openCallback: (name, e) => {
      switch (name) {
        case 'modal-record': openRecordModal(name, e);
          break;
      }
    },
    closeCallback: false,
  },
};

const openRecordModal = (name, e) => {
  const $tabsCaptions = document.querySelector(`[data-modal="${name}"] [data-tabs-captions]`);
  const $tabsBlocks = document.querySelector(`[data-modal="${name}"] [data-tabs-blocks]`);
  const type = e.target.dataset.openType;

  if ($tabsCaptions) {
    setActive($tabsCaptions, type === 'home' ? 1 : 0);
  }

  if ($tabsBlocks) {
    setActive($tabsBlocks, type === 'home' ? 1 : 0);
  }

  function setActive(node, newIndex) {
    for (let i = 0; i < node.children.length; i++) {
      const element = node.children[i];

      element.classList.remove(CLASSES.active);
      if (i === newIndex) {
        element.classList.add(CLASSES.active);
      }
    }
  }
};

const initModals = () => {
  const modalElements = document.querySelectorAll('.modal');

  if (modalElements.length) {
    modalElements.forEach((el) => {
      setTimeout(() => {
        el.classList.remove('modal--preload');
      }, 100);
    });
  }

  modals = new Modals(settings);
  // Используйте в разработке экспортируемую переменную modals, window сделан для бэкэнда
  window.modals = modals;
};

export {modals, initModals};


